import * as actionTypes from "Redux/Actions/actionTypes";

const initialState = {
  jsonData: [],
  success: "",
  error: "",
};

const TermsJsonReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TERMS_JSON_RESPONSE:
      return {
        ...state,
        success: action.success,
        error: "",
        jsonData: action.success.data,
      };
    case actionTypes.TERMS_JSON_ERROR:
      return {
        ...state,
        error: action.error,
        success: "",
      };

    default:
      return state;
  }
};

export default TermsJsonReducer;
